import React, { useEffect, useState } from 'react';
import { logger } from '@nykaa/logger';
import styled from 'App/styled';
import { getWidgets } from 'store/adPlatform/service';
import Widgets from 'components/Widgets';
import {
  EMPTY_STATE_URL,
  FETCH_ACTION_ERROR,
  FETCH_ERROR,
  POPULAR_BRAND,
  POPULAR_BRAND2,
} from '../constant';

const Section = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #fff2f1;
  width: 100%;
`;

const Title = styled.div`
  ${({ theme }) => theme.typography.titleSmall};
  margin-bottom: ${({ theme }) => theme.spacing.spacing40};
`;

const SubTitle = styled.div`
  ${({ theme }) => theme.typography.subTitleLarge};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const Msg = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: ${({ theme }) => theme.spacing.spacing240};
`;

const GoBack = styled.a`
  ${({ theme }) => theme.typography.titleXSmall};
  color: ${({ theme }) => theme.colors.primary};
`;

const WidgetWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.spacing80};
`;

interface SearchErrorProps {
  title: string;
  subTitle: string;
  redirectText: string;
  searchTerm?: string;
}

const SearchError = ({
  searchTerm,
  title,
  subTitle,
  redirectText,
}: SearchErrorProps) => {
  const [popularBrandsWidget, setPopularBrandsWidget] = useState([]);
  const fetchPopularBrandsWidgets = async (params: any) => {
    const requestParams = {
      ...params,
    };

    try {
      const widgets = await getWidgets(requestParams, '');
      return widgets;
    } catch (err) {
      logger.error(err, FETCH_ERROR);
    }
  };

  useEffect(() => {
    const widgetParams = {
      page_type: 'beauty-desktop-no-search-results-revamp',
      page_data: 'default',
      page_section: '*',
      device: 'desktop',
      platform: 'dweb',
      api_version: '',
    };
    fetchPopularBrandsWidgets(widgetParams)
      .then((data) => {
        const brandsData = data.filter(
          (widget: { inventoryPageSection: string }) =>
            widget.inventoryPageSection === POPULAR_BRAND ||
            widget.inventoryPageSection === POPULAR_BRAND2
        );
        setPopularBrandsWidget(brandsData);
      })
      .catch((err) => {
        logger.error(err, FETCH_ACTION_ERROR);
      });
  }, []);

  return (
    <>
      <Section>
        <Msg>
          <Title>
            {title}
            {searchTerm && ` "${searchTerm}"`}
          </Title>
          <SubTitle>
            {subTitle} <GoBack href="/">{redirectText}</GoBack>
          </SubTitle>
        </Msg>
        <img
          src={EMPTY_STATE_URL}
          alt="not_found"
        />
      </Section>
      {popularBrandsWidget && popularBrandsWidget.length > 0 && (
        <WidgetWrapper>
          <Widgets widgets={popularBrandsWidget} />
        </WidgetWrapper>
      )}
    </>
  );
};

export default SearchError;
